/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
/**
 * 
 * @export
 * @interface CustomerStatusCountDto
 */
export interface CustomerStatusCountDto {
    /**
     * Aktif, görülüşüyor veya sistemi kullanıyor
     * @type {number}
     * @memberof CustomerStatusCountDto
     */
    active?: number;
    /**
     * Eski müşteri veya satış gerçekleşmedi
     * @type {number}
     * @memberof CustomerStatusCountDto
     */
    passive?: number;
    /**
     * Müşteri olmaya yakın
     * @type {number}
     * @memberof CustomerStatusCountDto
     */
    potential?: number;
}

/**
 * Check if a given object implements the CustomerStatusCountDto interface.
 */
export function instanceOfCustomerStatusCountDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomerStatusCountDtoFromJSON(json: any): CustomerStatusCountDto {
    return CustomerStatusCountDtoFromJSONTyped(json, false);
}

export function CustomerStatusCountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerStatusCountDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'passive': !exists(json, 'passive') ? undefined : json['passive'],
        'potential': !exists(json, 'potential') ? undefined : json['potential'],
    };
}

export function CustomerStatusCountDtoToJSON(value?: CustomerStatusCountDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'passive': value.passive,
        'potential': value.potential,
    };
}

